import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { HUMANS, scenarios } from '../data/populations';
import { BRAND } from '../data/brand';
import { formatRatio } from '../utils/format';
import { LiveCounter } from '../components/LiveCounter';

/** Minimal iframe widget: /embed?theme=light|dark&scenario=verifiable|device|ambient */
export function Embed() {
  const [params] = useSearchParams();
  const theme = params.get('theme') === 'light' ? 'light' : 'dark';
  const scenario = scenarios.find(s => s.id === params.get('scenario')) ?? scenarios[1];
  const ratio = scenario.count / HUMANS.base;
  useEffect(() => {
    const html = document.documentElement;
    html.classList.add('ap-embed');
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    document.head.appendChild(meta);
    return () => {
      html.classList.remove('ap-embed');
      meta.remove();
    };
  }, []);
  return <div data-theme={theme} className="w-full bg-transparent p-4 font-sans text-ink" data-id="element-1135" data-mp="27ifdkzua8is8">
      <div className="grid grid-cols-2 gap-4" data-id="element-1136" data-mp="27g2toh4yrycj">
        <div data-id="element-1137" data-mp="23hvdpoibr12e">
          <p className="font-mono text-[10px] uppercase tracking-[0.16em] text-human" data-id="element-1138" data-mp="23iewt8jpnvi0">Humans</p>
          <p className="mt-1 text-[clamp(1.1rem,4.5vw,1.9rem)] leading-none text-human" data-id="element-1139" data-mp="2h90g2yd2u7gf">
            <LiveCounter base={HUMANS.base} baseTime={HUMANS.baseTime} ratePerSec={HUMANS.ratePerSec} label="Humans" data-id="element-1140" data-mp="2cgqkp2t70f6r" />
          </p>
        </div>
        <div data-id="element-1141" data-mp="2r89a1r7xzm2s">
          <p className="font-mono text-[10px] uppercase tracking-[0.16em] text-machine" data-id="element-1142" data-mp="2m7ljf6nml793">Machines · {scenario.label}</p>
          <p className="mt-1 text-[clamp(1.1rem,4.5vw,1.9rem)] leading-none text-machine" data-id="element-1143" data-mp="307cscszabxg8">
            <LiveCounter base={scenario.count} baseTime={HUMANS.baseTime} ratePerSec={scenario.ratePerSec} label="Machines" data-id="element-1144" data-mp="2v7i46x6w9lyv" />
          </p>
        </div>
      </div>
      <div className="mt-3 flex items-center justify-between gap-3 border-t border-line pt-2 font-mono text-[11px] text-muted" data-id="element-1145" data-mp="15v6874oey6bs">
        <span data-id="element-1146" data-mp="30wi2cmdt9qwe">
          <span className="text-ink" data-id="element-1147" data-mp="30x1l25bacjbh">{formatRatio(ratio)}</span> agents per human
        </span>
        <a href={`${BRAND.url}/`} target="_blank" rel="noopener noreferrer" className="hover:text-machine" data-id="element-1148" data-mp="35ujiozjurc46">
          Source: {BRAND.domain}
        </a>
      </div>
    </div>;
}